import { Helmet } from 'react-helmet';

import { IonText } from '@ionic/react';

import styles from './NotFound.module.scss';

import { APP_TITLE } from '../../constants/app';
import { GitLiveLogo } from '../../stories/GitLiveLogo/GitLiveLogo';

export default function NotFound() {
  return (
    <section className={styles.container}>
      <Helmet>
        <title>{APP_TITLE} - Not Found</title>
      </Helmet>
      <GitLiveLogo />
      <IonText color="light">
        Oops, something went wrong! <strong>404</strong>.
      </IonText>
    </section>
  );
}
